
/*******************************************************************************
 * regProductFormsService */
/**
 * @ngdoc   service
 * @module  books.ui.regProductForms
 * @name    books.ui.regProductForms.service:RegProductForms
 *
 * @description
 * Service object for communicating with the RegProductFormsController on the server.
 *******************************************************************************/
/* @ngInject */ export function RegProductFormsService(CSMHttp, Session) {
  function post(method, data) {
    return CSMHttp.post(serviceUrl(method), data);
  }
  function serviceUrl(method) {
    return Session.getSessionURL('books/regProductForms/' + method);
  }

  /*****************************************************************************
   * getProductList
   *
   * Gets the list of items.
   *****************************************************************************/
  this.getProductList = function () {
    return post('getProductList').then(function (resp) {
      return resp.data;
    });
  };
}